export const getGroupProducts = (page?: number) => ({
  type: "@saga/GET_GROUP_PRODUCTS",
  payload: page,
});
